import ArrowSmallRightIcon from "@heroicons/react/24/solid/ArrowSmallRightIcon";
import AtSymbolIcon from "@heroicons/react/24/solid/AtSymbolIcon";
import UserIcon from "@heroicons/react/24/solid/UserIcon";
import TextArea from "@/components/views/add-place/TextArea";
import { Checkbox } from "@/components/ui/checkbox";
import { Link } from "@/components/CustomLink";
import { ROUTES } from "@/@core/constants/routes";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/views/add-place/Input";
import SheetModal from "@/components/ui/sheet-modal";
import { useState } from "react";
import toast from "react-hot-toast";
import validateStringLength from "@/lib/validate-string-length";
import isMailPassAble from "@/lib/is-mail-passable";
import PhoneInput from "@/components/ui/phone-input";
import isPhoneValid from "@/lib/is-phone-valid";
import apiFetch from "@/lib/fetch";
import { useTranslation } from "@/hooks/translationContext";

interface Props {
  isOpen: boolean;
  setOpen: any;
}

export default function ContactModal(props: Props) {
  const { t } = useTranslation();
  const { isOpen, setOpen } = props;

  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [mail, setMail] = useState("");
  const [text, setText] = useState("");
  const [checked, setChecked] = useState(true);

  function isCommentPassAble() {
    return text.length > 10;
  }

  const post = async () => {
    const req = await apiFetch({
      route: "mail/contact",
      method: "POST",
      body: {
        fullName: name,
        mail,
        phoneNumber,
        text,
      },
    });

    return req === true ? true : req.statusCode === 201;
  };

  const onSubmit = () => {
    if (!isFormPassAble()) return;
    post()
      .then((r) =>
        r
          ? toast.success(t("contact-modal-send-success"))
          : toast.error(t("contact-modal-send-error")),
      )
      .catch(() =>
        toast.error(t("contact-modal-send-error")),
      );
  };

  const isFormPassAble = () => {
    return (
      validateName() &&
      isMailPassAble(mail) &&
      isCommentPassAble() &&
      isPhoneValid(phoneNumber) &&
      checked
    );
  };

  const validateName = () => {
    return validateStringLength(name, 3, 50);
  };

  return (
    <SheetModal isOpen={isOpen} onClose={() => setOpen(false)}>
      <div className="w-full flex flex-col items-center gap-4">
        <h1 className="text-xl font-bold text-secondary">
          Site Yönetimi ile İletişime Geçin
        </h1>

        <Input
          onChange={(e: ReactEvents.ChangeEvent<HTMLInputElement>) =>
            setName(e.target.value)
          }
          icon={<UserIcon className="size-6 text-assistant" />}
          placeholder={t("user-register-fullname-placeholder")}
          id="name"
          error={!validateName()}
          errorMessage={t("contact-modal-fullname-length-warning")}
        />

        <Input
          onChange={(e: ReactEvents.ChangeEvent<HTMLInputElement>) =>
            setMail(e.target.value)
          }
          icon={<AtSymbolIcon className="size-6 text-assistant" />}
          placeholder="E-Posta Adresiniz"
          id="email"
          error={mail.length < 10 || !isMailPassAble(mail)}
          errorMessage={t("contact-modal-email-invalid-warning")}
        />

        {/*<Input onChange={(e: ReactEvents.ChangeEvent<HTMLInputElement>) => setPhone(e.target.value)}*/}
        {/*       icon={<HiMiniDevicePhoneMobile className="text-2xl text-assistant"/>}*/}
        {/*       placeholder="Telefon Numaranız"*/}
        {/*       id="phone"*/}
        {/*       error={phone.length < 10 || !validatePhoneNumber(phone)}*/}
        {/*       errorMessage={t("contact-modal-phone-invalid-warning")}*/}
        {/*/>*/}

        <PhoneInput
          value={phoneNumber}
          setValue={setPhoneNumber}
          error={phoneNumber.length < 10 || !isPhoneValid(phoneNumber)}
          errorMessage={t("contact-modal-phone-invalid-warning")}
        />

        <TextArea
          placeholder="Mesajınız"
          icon={<ArrowSmallRightIcon className="size-6 text-assistant" />}
          onChange={(e: ReactEvents.ChangeEvent<HTMLTextAreaElement>) =>
            setText(e.target.value)
          }
          id="comment"
          error={!isCommentPassAble() || text.length < 10}
          errorMessage={t("contact-modal-message-min-length-warning")}
        />

        <label
          onClick={() => setChecked(!checked)}
          defaultChecked={true}
          className="w-full flex items-center gap-2 text-primary text-sm font-bold"
        >
          <Checkbox checked={checked} className="rounded-lg w-6 h-6" />

          <span className="flex gap-1 items-center flex-wrap">
            <Link href={ROUTES.LEGAL.TERMS} className="underline">
              Kullanım Koşulları
            </Link>
            ve
            <Link href={ROUTES.LEGAL.WARNING} className="underline">
              Yasal Uyarı
            </Link>
            okudum, kabul ediyorum
          </span>
        </label>

        <Button
          disabled={!isFormPassAble()}
          onClick={() => onSubmit()}
          className="bg-[#15bbae] disabled:bg-gray-300 hover:bg-[#15bbae] rounded-2xl py-3 text-white font-bold text-sm w-full"
        >
          İletişime Geç
        </Button>
      </div>
    </SheetModal>
  );
}
